import { DateHelper, StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";

export const form27 = (record: any) => {
  return {
    departmentCode: "1",
    aflType: AFLType.AFLNoSalary,
    layout: [
      {
        type: "header",
        value: {
          form: 1,
          department: StringHelper.verticalBarSplit(record?.eDepartment)[1],
        },
      },
      { type: "title", value: { sub: [] } },
      {
        type: "salutation",
        value: [
          "Tổng Giám đốc",
          `Trưởng phòng ${
            StringHelper.verticalBarSplit(record?.eUnit)[1]
          };`,
          "Trưởng phòng Tổ chức và Nhân lực.",
        ],
      },
      {
        type: "content",
        value: [
          { type: "eRequestName", value: record?.eRequestName },
          { type: "eEmployeeId", value: record?.eEmployeeId },
          {
            type: "ePosition",
            value: StringHelper.verticalBarSplit<string[]>(record?.eTeam)[1],
          },
          {
            type: "",
            value: `Đơn vị: ${
              StringHelper.verticalBarSplit<string[]>(record?.eDepartment)[1]
            }`,
          },
          { type: "eAddress", value: record?.eAddress },
          { type: "eBusinessTime", value: record?.eBusinessTime || "" },
          { type: "eReason", value: record?.eReason },
          {
            type: "",
            value: `Nay tôi kính mong ông Tổng Giám đốc cho phép tôi được nghỉ không lương tại ${
              record?.eAddress
            }. kể từ ${DateHelper.formatDateToString(
              record?.eVacationPeriod[0]
            )} đến ${DateHelper.formatDateToString(
              record?.eVacationPeriod[1]
            )}.`,
          },
          {
            type: "",
            value: `Tôi xin cam đoan trả lại ${
              record?.eAssetReturnNum || "   "
            } các trang thiết bị, vật tư, công cụ dụng cụ (nếu được cấp), thẻ công tác và thực hiện các thủ tục thanh toán nghỉ không lương theo đúng quy định của Công ty và của Pháp luật hiện hành.`,
          },
          { type: "", value: "Xin trân trọng cảm ơn." },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["TRƯỞNG PHÒNG TCNL", record?.eApprovalProcess[3][0].name],
          },
          {
            type: "signature1",
            value: ["THỦ TRƯỞNG ĐƠN VỊ", record?.eApprovalProcess[1][0].name],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "recipients",
            value: ["- Như trên;", "- Lưu TCNL."],
          },
          {
            type: "signature1",
            value: [
              "PHÊ DUYỆT CỦA TỔNG GIÁM ĐỐC",
              record?.eApprovalProcess[4][0].name,
            ],
          },
        ],
        textBreak: 1,
      },
    ],
  };
};
